class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.handleReady = this.loadRecentlyViewed.bind(this);
    this.hasLoadedRecentlyViewed = false;
  }

  connectedCallback() {
    this.moveToPdpBottom();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.handleReady, { once: true });
      return;
    }

    this.loadRecentlyViewed();
  }

  disconnectedCallback() {
    document.removeEventListener('DOMContentLoaded', this.handleReady);
  }

  moveToPdpBottom() {
    var mainProduct = document.querySelector('.main-product');
    if (!mainProduct) return;

    var sectionRoot = this.closest('.shopify-section');
    if (!sectionRoot) return;

    var mainContent = document.getElementById('MainContent');
    if (mainContent && sectionRoot.parentElement === mainContent && mainContent.lastElementChild !== sectionRoot) {
      mainContent.appendChild(sectionRoot);
    }
  }

  loadRecentlyViewed() {
    if (this.hasLoadedRecentlyViewed) return;
    this.hasLoadedRecentlyViewed = true;

    var COOKIE_NAME = 'recently_viewed_products';
    var MAX_PRODUCTS = 4;
    var SECTION_ID = 'product-card';
    var sliderRoot = this.querySelector('.recently-viewed-products__cards');
    if (!sliderRoot) return;

    function forceHide(element) {
      if (!element) return;
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
    }

    function hideProductDiscoverySections() {
      document.querySelectorAll('related-products, product-recommendations').forEach(function (section) {
        forceHide(section);
      });
    }

    if (document.querySelector('.carryology-oos-banner__image')) {
      forceHide(this);
      hideProductDiscoverySections();
      return;
    }

    var rawCookie = typeof getCookie === 'function' ? getCookie(COOKIE_NAME) : '';
    if (rawCookie == null || String(rawCookie).trim() === '') return;

    function readHandleList() {
      var raw = typeof getCookie === 'function' ? getCookie(COOKIE_NAME) : '';
      if (!raw) return [];
      try {
        var parsed = JSON.parse(decodeURIComponent(raw));
        if (Array.isArray(parsed)) {
          return parsed.filter(function (h) {
            return typeof h === 'string' && h.length;
          });
        }
      } catch (e) {}
      try {
        var parsed2 = JSON.parse(raw);
        if (Array.isArray(parsed2)) {
          return parsed2.filter(function (h) {
            return typeof h === 'string' && h.length;
          });
        }
      } catch (e2) {}
      return [];
    }

    var handles = readHandleList().slice().reverse();
    if (!handles.length) return;

    var currentPdp = document.querySelector('.main-product');
    var currentHandle = currentPdp ? currentPdp.getAttribute('data-handle') : null;
    if (currentHandle) {
      handles = handles.filter(function (h) {
        return h !== currentHandle;
      });
    }

    handles = handles.slice(0, MAX_PRODUCTS);

    if (!handles.length) return;

    var sentinel = this.querySelector('.recently-viewed-products__intersect-sentinel');
    var inner = this.querySelector('.recently-viewed-products__inner');
    if (!sentinel) return;

    var handleIntersection = function (entries, observer) {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(sentinel);

      var parser = new DOMParser();
      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID).then(function (res) {
            if (!res.ok) return null;
            return res.text();
          });
        })
      )
        .then(function (htmlParts) {
          var drag = false;
          htmlParts.forEach(function (html) {
            if (!html) return;
            var doc = parser.parseFromString(html, 'text/html');
            var card = doc.querySelector('.product-card');
            if (!card) return;
            card.classList.add('keen-slider__slide', 'recently-viewed-product-card');
            sliderRoot.appendChild(document.importNode(card, true));
          });

          if (!sliderRoot.children.length) return;

          if (inner) inner.classList.remove('hidden');

          if (typeof productCardColorUpdateFunction === 'function') {
            productCardColorUpdateFunction();
          }
          window.productCardColorSwatchesScroll?.(sliderRoot.closest('.recently-viewed-products') || document);

          if (typeof KeenSlider !== 'function' || typeof navigation !== 'function') return;

          new KeenSlider(
            sliderRoot,
            {
              dragChecked: function () {
                drag = true;
              },
              dragEnded: function () {
                setTimeout(function () {
                  drag = false;
                }, 0);
              },
              created: function () {
                sliderRoot.addEventListener('click', function (e) {
                  if (drag) {
                    e.stopPropagation();
                    e.preventDefault();
                  }
                });
              },
              breakpoints: {
                '(max-width: 449px)': {
                  slides: { perView: 1.35, spacing: 4 },
                },
                '(min-width: 450px)': {
                  slides: { perView: 2.5, spacing: 4 },
                },
                '(min-width: 990px)': {
                  disabled: true,
                },
              },
            },
            [navigation]
          );

          window.initProductCardVideos?.(sliderRoot.closest('.recently-viewed-products') || document);
        })
        .catch(function (e) {
          console.error(e);
        });
    };

    var observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0,
      rootMargin: '2000px',
    });

    observer.observe(sentinel);
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
